import React, { useState } from "react";
import { toast } from "sonner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./testForm.css";
import emailjs from "@emailjs/browser";

const TestForm = ({ setShowModal, preferredClass = "" }) => {
  const [loading, setLoading] = useState(false);

  const initialState = {
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    mockClass: "",
  };
  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required!"),
    middleName: Yup.string(),
    lastName: Yup.string().required("Required!"),
    email: Yup.string().email("Invalid Email").required("Required!"),
    contactNumber: Yup.string()
      .matches(/^9\d{9}$/, "Must start with 9 and be exactly 10 digits")
      .required("Required!"),
    mockClass:
      preferredClass === "Mock Test"
        ? Yup.string().required("Required!")
        : Yup.string(),
  });

  const onSubmit = (values, { resetForm }) => {
    const { firstName, middleName, lastName, email, contactNumber, mockClass } =
      values;

    setLoading(true);
    emailjs
      .send(
        "service_6ujn2di",
        "template_54ilffp",
        {
          from_name: `${firstName} ${middleName} ${lastName}`,
          from_email: email,
          contact_number: contactNumber,
          preferred_class: mockClass
            ? `${preferredClass}-(${mockClass})`
            : preferredClass,
          message: `I want to join ${preferredClass}.`,
        },
        "EKfcC2csrw8HLCvXk"
      )
      .then(
        () => {
          setLoading(false);
          toast.success(
            `Thank you ${firstName} ${middleName} ${lastName} for your request. We will reach out to you very soon.`
          );
          resetForm();
          setShowModal(false);
        },
        () => {
          setLoading(false);
          toast.error("Failed to contact us. Please try again.");
        }
      );
  };
  return (
    <div className="test-form-container">
      <div className="test-form">
        <h2>Register for a {preferredClass} Class</h2>
        <Formik
          initialValues={initialState}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {() => (
            <Form>
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="input-group">
                    <label htmlFor="firstName">First Name</label>
                    <Field
                      type="text"
                      id="firstName"
                      name="firstName"
                      placeholder="First Name"
                    />
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      className="error-text text-danger"
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="input-group">
                    <label htmlFor="middleName">Middle Name</label>
                    <Field
                      type="text"
                      id="middleName"
                      name="middleName"
                      placeholder="Middle Name"
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="input-group">
                    <label htmlFor="lastName">Last Name</label>
                    <Field
                      type="text"
                      id="lastName"
                      name="lastName"
                      placeholder="Last Name"
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      className="error-text text-danger"
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="input-group">
                    <label htmlFor="contactNumber">Contact Number</label>
                    <Field
                      type="tel"
                      id="contactNumber"
                      name="contactNumber"
                      placeholder="Contact Number"
                    />
                    <ErrorMessage
                      name="contactNumber"
                      component="div"
                      className="error-text text-danger"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="input-group">
                    <label htmlFor="email">Email</label>
                    <Field
                      type="text"
                      id="email"
                      name="email"
                      placeholder="Email"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      className="error-text text-danger"
                    />
                  </div>
                </div>
                {preferredClass === "Mock Test" && (
                  <div className="col-12">
                    <div className="input-group">
                      <label htmlFor="mockClass">Select Class</label>
                      <Field as="select" id="mockClass" name="mockClass">
                        <option value="" disabled>
                          Select Class
                        </option>
                        <option value="IELTS">IELTS</option>
                        <option value="PTE">PTE</option>
                      </Field>
                      <ErrorMessage
                        name="mockClass"
                        component="div"
                        className="error-text text-danger"
                      />
                    </div>
                  </div>
                )}
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading && (
                  <div className="spinner-border text-dark" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
                &nbsp;Submit
              </button>
              <button
                type="button"
                className="btn btn-lg btn-outline-danger mt-2"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default TestForm;
